module.exports = __webpack_public_path__ + "static/media/3022.c8e6dc4a.jpg";